import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Button,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { GoogleLogin } from "react-google-login"
import { loginUser, socialLogin } from "../../store/actions"
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { facebook, google } from "../../config"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEnvelope,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons"
import { motion } from "framer-motion"
import "./Login.css"
import DevelopedByMrp from "./DevelopedByMrp"
import LoadingSpinnerSmall from "components/Common/LoadingSpinner/LoadingSpinnerSmall"

const Login = props => {
  //meta title
  document.title = "Login | Leads Plataform - Blops"

  const dispatch = useDispatch()

  const { apiStatus } = useSelector(state => state?.Login)
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Por favor informe seu E-mail"),

      password: Yup.string().required("Por favor informe sua Senha"),
    }),
    onSubmit: values => {
      setLoading(true)
      dispatch(loginUser(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      }
      dispatch(socialLogin(postData, props.history, type))
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      }
      dispatch(socialLogin(postData, props.history, type))
    }
  }

  const googleResponse = response => {
    signIn(response, "google")
  }

  const facebookResponse = response => {
    signIn(response, "facebook")
  }

  return (
    <React.Fragment>
      <div className="mainContainer">
        <div className="login-wrapper">
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="login-card-container"
          > */}
          <div className="login-inner-card">
            <div className="login-header">
              <motion.img
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
                src="https://blops.com.br/wp-content/uploads/2022/06/Logo_azul.png"
                alt="Logo"
                className="login-logo"
              />
              <h4 className="welcome-text">Seja Bem-vindo!</h4>
              <p className="welcome-subtext">a Plataforma Leads</p>
            </div>

            <div className="login-form-container">
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                {error && <Alert color="danger">{error}</Alert>}

                <div className="login-form">
                  <div className="input-group">
                    <div className="input-wrapper">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="input-icon"
                      />
                      <input
                        name="email"
                        type="email"
                        className={`custom-input ${
                          validation.touched.email && validation.errors.email
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder=" E-mail"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                      />
                    </div>
                    {validation.touched.email && validation.errors.email && (
                      <div className="error-message">
                        {validation.errors.email}
                      </div>
                    )}
                  </div>

                  <div className="input-group">
                    <div className="input-wrapper">
                      <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEye : faEyeSlash}
                          className="input-icon"
                        />
                      </button>
                      <input
                        name="password"
                        type={showPassword ? "text" : "password"}
                        className={`custom-input ${
                          validation.touched.password &&
                          validation.errors.password
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Senha"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                      />
                    </div>
                    {validation.touched.password &&
                      validation.errors.password && (
                        <div className="error-message">
                          {validation.errors.password}
                        </div>
                      )}
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="login-button"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <LoadingSpinnerSmall /> : "Entrar"}
                </motion.button>

                {/* Botão Cadastre-se */}
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="register-button"
                  // onClick={() => navigate("/register")}
                >
                  Cadastre-se
                </motion.button>

                <div className="forgot-password-container">
                  <p>
                    Esqueceu sua senha? Clique aqui em{" "}
                    <Link to="/forgot-password" className="reset-link">
                      Recuperar minha senha
                    </Link>
                  </p>
                </div>

                {/* Google Login Button - Commented out as requested */}
                {/* <div className="social-login">
                  <div className="separator">
                    <span>Ou continue com</span>
                  </div>
                  <GoogleLogin
                    clientId={google.CLIENT_ID}
                    render={renderProps => (
                      <motion.button
                        className="google-button"
                        onClick={renderProps.onClick}
                      >
                        <img
                          src="https://www.svgrepo.com/show/475656/google-color.svg"
                          alt="Google Logo"
                          className="google-icon"
                        />
                        Entrar com Google
                      </motion.button>
                    )}
                    onSuccess={googleResponse}
                    onFailure={() => {}}
                  />
                </div> */}
              </Form>
            </div>
          </div>
          {/* </motion.div> */}
        </div>
        <DevelopedByMrp />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
